import { a1Discover as apiA1Discover } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { A1Action, A1ActionTypes } from "./A1";

/** @deprecated */
export const dismissA1DiscoverError = () => (dispatch: Dispatch<A1Action>) =>
  dispatch({ type: A1ActionTypes.A1_DISCOVER_ERROR });

/** @deprecated */
export const a1Discover = (planId: string, wifi: boolean, msisdn?: string) => {
  return (dispatch: Dispatch<A1Action>) => {
    return new Promise<string>((resolve, reject) => {
      dispatch({ type: A1ActionTypes.A1_DISCOVER_REQUEST });
      apiA1Discover(planId, wifi, msisdn).subscribe({
        next: (res) => {
          dispatch({
            type: A1ActionTypes.A1_DISCOVER_SUCCESS,
            redirectURI: res.redirectUrl,
          });
          resolve(res.redirectUrl);
        },
        error: (error) => {
          dispatch({ type: A1ActionTypes.A1_DISCOVER_ERROR, error });
          reject(error);
        },
      });
    });
  };
};
